import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

export default class FinancialServicesStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options.
	 * @param options.theme Theme.
	 * @returns Styles.
	 */
	public static getStyle(options: { theme: ITheme }): string {
		return css`
			:host {
				display: flex;
				color: ${options.theme.color.neutral.grey900};
			}
		`;
	}
}
